import { Link } from '@tanstack/react-router';
import { ArrowRight } from 'lucide-react';

/**
 * SIL-271 (W4-T11, resources/plans/erp-register-import-spec.md §1 decision
 * 7 — "every Financials 'not enough data' empty state deep-links into the
 * wizard"). The ERP register wizard itself is SIL-270's Integrations ERP
 * card + upload/mapper flow (parallel branch, not yet merged as of this
 * screen) — pending a dedicated wizard route this links to the Integrations
 * page, where the ERP card lives (spec §1 decision 7 "wizard ... live under
 * Integrations"). Update the `to` here once SIL-270 lands a more specific
 * route if one exists.
 */
export function ImportFromErpLink({ className }: { className?: string }) {
  return (
    <Link
      to="/integrations"
      className={
        className ??
        'mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-brand-600 hover:text-brand-700 hover:underline'
      }
    >
      Import from your ERP
      <ArrowRight className="size-3.5" />
    </Link>
  );
}
